
import { useEffect, useState } from 'react'
import { Iposts, Isubcatdata, ITrendsCategory, ICats } from '../../../interfaces'
import styles from './trendscategory.module.css'
import { NavLink } from '../../ui';
import Image from "next/image";
import { useGlobalContext } from '../../../lib/context';
import { CountryCode } from '../../../lib/constants';
import { TrendsCategoryType } from '../TrendsCategoryType';
import { cmsLoader } from '../../../lib/helpers/imageLoader';
import { TrendsProductTiles } from '../TrendsProductTiles';
import { pushRoute } from '@/lib/helpers/common';

type props = {
    countryCode: CountryCode
    categorySlug: string
    data: ITrendsCategory
}
export function TrendsCategory({ countryCode, data, categorySlug }: props) {
    const {props:{isMobileView}} = useGlobalContext();
    const siteURL = process.env.SITE_URL + "/" + countryCode;
    const scrolltile = (direction: string, categoryNameId: string) => {
        const productBxId: any = document.getElementById(categoryNameId);
        if (productBxId != null) {
            if (direction === "prev") {
                productBxId.scrollLeft -= isMobileView ? 100 : 160;
            } else {
                productBxId.scrollLeft += isMobileView ? 100 : 160;
            }
        }
    }

    return <>
      <TrendsCategoryType data={data.parent_cat} Selectedcategory={categorySlug}/>
        <div className={styles.incoCatagermain}>
            <div className="container">
                <div className={styles.incoCatbox}>
                    <div className={styles.incoCatagretiles}>
                    {data?.sub_cats.length >= 7 || isMobileView && data?.sub_cats.length >= 2 ? <button onClick={() => scrolltile("prev", 'trendsCategory')}>{'<'}</button> : null}  
                        <div className={styles.subCatName} id="trendsCategory" >
                            {data.sub_cats.map((slides: ICats, idx: number) =>
                                <NavLink href={`${siteURL}/trends/category/${data?.cat_slug}/${slides.sub_cat_slug}`} key={idx}>
                                    <div className={styles.incoRoomcat}>
                                        <figure>
                                            <Image
                                                src={`${slides.sub_cat_relative}`}
                                                alt="No-Icon"
                                                fill
                                                loader={cmsLoader}
                                                sizes="100vw"
                                                    />
                                        </figure>
                                        <p>{slides.sub_cat_name}</p>
                                    </div>
                                </NavLink>
                            )}
                        </div>
                        {data?.sub_cats.length >= 7 || isMobileView && data?.sub_cats.length >= 2 ? <button className={styles.leftRght} onClick={() => scrolltile("next", 'trendsCategory')} >{'<'}</button> : null }

                    </div>
                </div>
            </div>
        </div>

        <div className={`${styles.incoRoompt46} ${styles.incoLivingRoom} section `}>
        <div  className={` ${styles.inLivingBox} ${styles.active}`}>
            <div className="container">
                {data.sub_cat_data.map((subCats: Isubcatdata, index: number) =>
                    <div key={index} className={styles.trendsSectnBx}>
                            <div className={styles.trandsHeading}>
                                <p>
                                    <span><svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="m25.996.728-.517 5.02c-.06.551-.732.788-1.118.4l-1.224-1.23-7.708 7.754c-.484.486-1.336.486-1.82 0L9.365 8.4 2.19 15.621a1.28 1.28 0 0 1-1.814 0c-.501-.504-.501-1.322 0-1.83l8.08-8.129c.484-.487 1.336-.487 1.815 0l4.25 4.271 6.802-6.842-1.434-1.442c-.39-.392-.154-1.068.393-1.124l4.991-.52a.657.657 0 0 1 .723.723z" fill="#EB5976" />
                                    </svg></span>
                                </p>
                                 <h2 className={`${styles.trandsHead} font16 text222`}>{subCats.sub_cat_name} </h2>

                                <span className={`link font16 ${styles.viewall}`} onClick={()=>pushRoute(`${siteURL}/trends/category/${data.cat_slug}/${subCats.sub_cat_slug}`)}>View All</span>
                            </div>
                            <div className={`${styles.inLivingBox}`}>
                                {subCats.posts.map((posts: Iposts, idx: number) =>
                                    <TrendsProductTiles posts={posts} subcategories={subCats} categorySlug={data.cat_slug} key={idx}/>
                                )}
                            </div>
                    </div>)}
            </div>
        </div>
        </div>
    </>;
}